import React from 'react';
import { Text } from '@doordash/design-language';
import Button, { ButtonType, ButtonSize } from '@doordash/component-button';
import { BannerActionsWrapper } from './styles.js';
import { BannerType } from './types.js';
import { bannerConfig } from './utils.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var BannerActions = function BannerActions(_ref) {
  var actionPosition = _ref.actionPosition,
      primaryAction = _ref.primaryAction,
      secondaryAction = _ref.secondaryAction,
      variant = _ref.variant,
      type = _ref.type;
  var primaryButtonType = type === BannerType.Subdued ? ButtonType.Tertiary : ButtonType.Plain;
  var isPrimaryButtonRaised = type === BannerType.Subdued ? false : true;
  var bannerColors = bannerConfig[variant][type];
  var textColor = Text.Colors[bannerColors.secondaryButton];
  return /*#__PURE__*/React.createElement(BannerActionsWrapper, {
    actionPosition: actionPosition
  }, !!primaryAction && /*#__PURE__*/React.createElement(Button, _extends({}, primaryAction.buttonProps, {
    isInline: true,
    size: ButtonSize.Small,
    type: primaryButtonType,
    isRaised: isPrimaryButtonRaised,
    onClick: primaryAction.onClick
  }), primaryAction.content), !!secondaryAction && /*#__PURE__*/React.createElement(Button, _extends({}, secondaryAction.buttonProps, {
    isInline: true,
    size: ButtonSize.Small,
    type: ButtonType.FlatSecondary,
    onClick: secondaryAction.onClick
  }), /*#__PURE__*/React.createElement(Text, {
    styles: Text.Styles.ButtonSmallTitle,
    color: textColor
  }, secondaryAction.content)));
};

export { BannerActions as default };
